module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "center",
    attrs: {
      "wide": false,
      "show-close": false,
      "width": "400px"
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('p', [_c('b', [_vm._v("Du har redan ett boende i varukorgen")])]), _vm._v(" "), (_vm.accomodation && _vm.accomodation.name) ? _c('h1', {
    staticClass: "accomodation-title"
  }, [_vm._v(_vm._s(_vm.accomodation.name))]) : _vm._e(), _vm._v(" "), (_vm.accomodation) ? _c('AccomodationPeriodConfirm', {
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure,
      "small": true
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Om du vill boka flera boenden i samma bokning måste du välja samma datum.")]), _vm._v(" "), (!_vm.is_free) ? _c('p', [_vm._v("Den valda perioden är dock inte tillgänglig för detta boende.")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.is_free) ? _c('button', {
    staticClass: "small",
    on: {
      "click": _vm.goToInfo
    }
  }, [_vm._v("Okej, gå vidare och boka")]) : _vm._e(), _vm._v(" "), (!_vm.is_free) ? _c('button', {
    staticClass: "small",
    on: {
      "click": _vm.goToSearch
    }
  }, [_vm._v("Okej, gå tillbaka till sök")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "5px"
    }
  }), _vm._v(" "), (_vm.is_free) ? _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.goToSearch
    }
  }, [_vm._v("Tillbaka")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.goToCart
    }
  }, [_vm._v("Avbryt och gå till varukorg")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-658f278e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SecondAccomodationModal.vue
// module id = 986
// module chunks = 0